/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_sq.js                                                                                */
/**********************************************************************************************************************/
/* Controller.SQ */

HafasWebapp.prototype.Controller.SQ = {
  stationMarker: null,
  stationInfoMarker: null,
  additionalInstances: {},
  stopsNearby: [],
  storage: null,
  currentShownNearStops: [],
  currentNearStopsFilter: [],
  currentNearStops: [],
  infoMap: null,
  currentForm: null,    // um außerhalb von postForm eine Referenz auf das Formular zu haben; wird in index gesetzt
  localOptionsActive: Hafas.Config.Options.storeOptions, // Flag used to save if the options should be saved locally, false if the options are specified via URL parameters
  storeSortOptionsLocally: Hafas.Config.Options.storeOptions, // Flag used to save if the sort options should be saved locally, false if the sort options are specified via URL parameters
  localOptionsLoaded: false, // Flag used to save whether the options were loaded once from the storage at webapp / context start
  focusSelector: null, // for restoring focus after some action is performed
  index: function (data) {
    // Flag, welches die Suche aus einem anderen Kontext markiert, in jedem Fall beim Aufruf der index-Funktion wieder zurücksetzen.
    // Der Modus soll nämlich dann in jedem Falle verlassen werden, wenn das Formular angezeigt wird
    delete this.Controller.SQ.searchFromOtherContextActive;
    this.Controller.SQ.storage = Hafas.Core.newType('hafasStorage');
    var me = this;
    data = data || {};

    Hafas.bind(this.Controller.SQ.cleanup, this)();
    if (Hafas.Config.Switches.useFavorites) {
      this.Controller.Favorites.instance.checkDataConsistency();
      // Wenn allType Suche im Stationboard erlaubt ist, müssen die Favoriten nicht gefiltert werden
      if (Hafas.Config.SQ.allType) {
        var favorites = this.Controller.Favorites.instance.getData();
      } else {
        // getData(1): alle locations, die nicht vom Typ 1 (Station) sind,
        // erhalten den Wert display = false. Auf diesen wird im Template common.tabs.html geprüft
        var favorites = this.Controller.Favorites.instance.getData("S");
      }
    }

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("SQ", "index", {});

    // Model wird von AtomModel übernommen und erweitert.
    var model = {};
    var storedOptions = {};

    if (Hafas.Config.SQ.useQueryOptions) {
      model.customerOptions = me.Controller.SQ.options.get();
      model.optionsChanged = me.Controller.SQ.options.haveOptionsChanged();
      model.useOptions = true;
    }

    model.fltrL = me.Controller.SQ.fltrL;

    // TODO: Classic version ist in der Lyra nicht vertreten
    /**
     * Fuer die Classic-Version muss es konfigurierbar sein, ob die "Optionen" von vornherein angezeigt werden sollen
     * oder ob sie über den Link "Optionen" eingeblendet werden sollen
     * Aus der switches.tpl und der js_hafasconfig.tpl erhalten wir "showOptionsOnInit"
     */
    model.showOptionsOnInit = Hafas.Config.UI.showOptionsOnInit;

    var useFavorites = Hafas.Config.Switches.useFavorites;
    if (Hafas.Config.SQ.allType == true) {
      model.customerFavorites = useFavorites ? me.Controller.Favorites.instance.getData() : null;
      model.sqInputLabelText = Hafas.Modules.i18n.get('SQ.label.t_N_enterStopLocation');
    } else {
      model.customerFavorites = useFavorites ? me.Controller.Favorites.instance.getData("S") : null;
      model.sqInputLabelText = Hafas.Modules.i18n.get('SQ.label.t_N_enterStop')
    }

    // Prüfen ob Location gesetzt ist, und entsprechend im model vorbelegen:
    var currentLocation = me.Controller.SQ.instance.getLocation();
    if (currentLocation != null && typeof currentLocation.name != 'undefined') {
      model.stationInput = currentLocation.name;
      Hafas.bind(this.Controller.SQ.setLocationMarker, this)(currentLocation);
    }

    // EuSpirit Start
    if (Hafas.Config.Switches.useEuSpirit && Hafas.Config.euSpiritRegions && Hafas.Config.euSpiritRegions.length !== 0) {

      var euRegionOptions = Hafas.Config.euSpiritRegions.map(function (region, index) {
        var result = {
          index: index,
          value: region.prvCtx,
          id: region.prvCtx,
          group: region.optgroup,
          content: [{text: region.name}]
        };
        // Set selected if region is active
        if (me.Controller.SQ.euProvider && me.Controller.SQ.euProvider.Station && index === me.Controller.SQ.euProvider.Station.index) {
          result.selected = true;
        }
        return result;
      });
      // Check if any region was already selected; if false, select placeholder option
      var isOptionSelected = euRegionOptions.some(function (value) {
        return !!value.selected;
      })
      // Create empty placeholder option which is initially selected
      euRegionOptions.unshift({
        content: [{text: Hafas.Modules.i18n.get('SQ.index.t_N_EuSpiritRegion')}],
        disabled: true,
        selected: !isOptionSelected
      });

      this.Controller.SQ.euProvider = this.Controller.SQ.euProvider || {
        Station: {}
      };

      // Fill model with euSpiritOptions
      model.euSpiritOptions = {
        holder: 'HFS_EuSelectStationWrap',
        id: 'HFS_EuSelectStation',
        hideLabel: true,
        label: Hafas.Modules.i18n.get('SQ.index.t_N_EuSpiritRegion'),
        className: 'lyr_atomEuSelectWrapper',
        options: euRegionOptions,
        caretIcon: {
          icnClass: "lyr_atomExpandCollapse",
          className: "lyr_atomIcon16"
        },
        callback: function (data) {
          Hafas.ps.pub('/sq/changeEUSpiritOption', [{name: 'euRegion', value: data.value}]);
        }
      };
    }

    // Todo: unschün, es muss in die renderengine eine methode, die auch ineinander verschachtelete templateresourcen rendern kann
    // Todo: zurzeit muss der Loader gerufen werden anstatt direkt auf die Renderengine zu gehen, nicht gut, aber läuft
    Hafas.Core.newType("hafasLoader", {
      file: 'sq.index.html',
      tplId: 'SQ_TplIndex',
      callback: function (templateId) {
        Hafas.Modules.Render.render({
          target: me.formContainer,
          template: templateId,
          model: model
        }, function () {

          var formContainer = Hafas("#" + me.formContainer);
          me.Controller.SQ.currentForm = Hafas('#HFS_FormStationSearch', false, formContainer);

          if (Hafas.Config.debug.showDataModel) {
            console.log('+++ SQ.index +++ DEBUG Model +++', model)
          }

          // Lade eventuell geänderte Optionen in die Formular-GUI
          if (Hafas.Config.SQ.useQueryOptions) {
            var optionData = {
              context: 'SQ'
            };
            Hafas.ps.pub('/options/setChangedOptionsInputForm', [optionData]);
          }

          var sqSuggestConfig = {};
          if (Hafas.Config.SQ.allType) {
            sqSuggestConfig.suggestType = 'ALL';
          } else {
            sqSuggestConfig.suggestType = 'S';
          }
          var tmpLoc = me.Controller.SQ.instance.getLocation();
          me.Controller.SQ.inpStation = Hafas.Core.newType('hafasSuggest', {
            loc: "Station",
            config: sqSuggestConfig,
            type: "S",
            onSelect: function () {
              Hafas.ps.pub('/app/events/resize', [{}]);
              Hafas.bind(me.Controller.SQ.validateSelection, me)();
            }
          });

          if (tmpLoc != null && tmpLoc.name) {
            me.Controller.SQ.inpStation.setLocation(tmpLoc);
          }

          if (Hafas.Config.SQ.useQueryOptions) {
            Hafas.ps.pub('/options/init', [{context: "SQ"}]);
          }

          if (Hafas.Config.SQ.useQueryOptions && Hafas.Config.Options.storeOptions && me.Controller.SQ.localOptionsLoaded === false) {
            // Use stored options in loading the view once, if options are active and the storeOptions config is set
            Hafas.ps.pub('/options/storage/set');
            me.Controller.SQ.localOptionsLoaded = true;
          }

          // Autorefresh beim Aufruf der Eingabeseite immer zurücksetzen!!!
          me.Controller.SQ.instance.stopAutorefresh();

          // Vorbelegung "Anzahl Fahrten"
          var maxJnyBox = Hafas('[data-name="maxJourneys"]');
          // Wenn das Element vorhanden ist, dann
          if (maxJnyBox) {
            for (var g = 0; g < maxJnyBox.options.length; g++) {
              if (maxJnyBox.options[g].value == me.Controller.SQ.instance.getMaxJourneys()) {
                maxJnyBox.selectedIndex = g;
              }
            }
          }

          var historyDateTime = data.dateTime || {};
          var historyDate = historyDateTime.date;
          var historyTime = historyDateTime.time;
          var historyIsNowMode = historyDateTime.isNowMode;

          // if history wasn't created before, let stboard module decide how variables are set
          if (historyIsNowMode === undefined || historyIsNowMode === null)
            historyIsNowMode = me.Controller.SQ.instance.getTimeNow();
          if (historyDate === undefined || historyDate === null)
            historyDate = me.Controller.SQ.instance.getDate();
          if (historyTime === undefined || historyTime === null)
            historyTime = me.Controller.SQ.instance.getTime();

          // setting tdp-configuration
          var dateTimePickerConfig = {
            holder: "HFS_SqDateTimePickerHolder",
            id: "SQ_DTP",
            config: {
              useDepArrSwitch: false
            },
            current: {
              date: historyDate,
              time: historyTime,
              enquiry: true,
              isNowMode: historyIsNowMode
            }
          };
          // set stboard module dateTime from history, if view is restored
          me.Controller.SQ.setDateTime(historyDate, historyTime, historyIsNowMode);
          me.Controller.SQ.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);

          // Favoriten als SegmentedControl
          if (Hafas.Config.UI.showFavoriteBox === true) {
            Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_CustomerFavoritesWrap'}).initiate();
          }

          // EuSpirit Selectboxen
          if (Hafas.Config.Switches.useEuSpirit && Hafas.Config.euSpiritRegions && Hafas.Config.euSpiritRegions.length !== 0) {
            me.Controller.SQ['euSpiritSelectBox'] = Hafas.Core.newType('HafasSelectBox', model.euSpiritOptions).initiate({callback:true});
          }
          // EUSpirit Ende

          if (Hafas.Config.SQ.unifiedPlanner.show) {
            Hafas.Util.gui.setVisibility(Hafas('#HFS_SQActionBar', false), false);
            Hafas.Util.gui.setVisibility(Hafas('#HFS_CustomerFavoritesWrap', false), true);
          }

          Hafas.ps.pub('/app/events/renderDone');

          if (me.Controller.Common.initialStartSet == true) {
            Hafas.ps.pub('/GUI/form/hide');
          }

          // fülle die UIActions des SQ-Moduls
          // Common_TplFormUIActions
          if (document.getElementById(me.formUIHiddenActions)) {
            Hafas.Modules.Render.render(
            {
              file: 'common.partials.html',
              target: me.formUIHiddenActions,
              template: 'Common_TplFormUIActions',
              model: {
                appcontext: 'SQ'
              }
            },
            function (html) {
            }
            );
          }

          // Überprüfe aktuelle Position
          if (Hafas.Config.SQ.allType) {
            Hafas.ps.pub('/apis/geolocation/check');
          }

          // Track
          Hafas.ps.pub('/tracking/screen/stationboard-planner-main', [{
            typ: 'screen',
            key: 'stationboard-planner-main'
          }]);
          Hafas.ps.pub('/tracking/screen/stationboard-main', [{typ: 'screen', key: 'stationboard-main'}]);

          if (me.Controller.Common.initialStartSet === undefined) {
            Hafas.ps.pub('/GUI/form/show', [{}]);
          } else {
            // Wenn direkt über "start" Parameter gesucht wird, dann Formular ausblenden
            Hafas.ps.pub('/GUI/form/hide', [{}]);
          }
          Hafas.ps.pub('/favorites/update');
          Hafas.ps.pub('/app/updateBanner', ["sqInput"]);
          Hafas.ps.pub('/app/events/resize', [{}]);
          Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

          Hafas.bind(me.Controller.SQ.loadNearStops, me)();

          me.Controller.SQ.updateIndexHistory();

          Hafas.Util.gui.focusTabOrMenuButton();
        });
      }
    });
  },
  reEnterContext: function(data){
    // Wenn man bereits im Context SQ war, werden vor Ausführung der index Funktion ggfs. die zuvor ausgewählten
    if(data.context == 'SQ') {
      // Gab es eine bisherige Auswahl
      if (this.Controller.SQ.dateTimeActiveUserSelection !== undefined) {
        Hafas.bind(this.Controller.SQ.restoreOriginalUserInput,this)();
      }else{
        this.Controller.SQ.instance.setTimeNow(true);
      }
    }
  },
  /* Stellt eine ursprüngliche Zeit/Datums-Auswahl des Users wieder her, das ist notwendig, weil zwischendurch auch vom Trip Planner in das Stboard gesprungen werden kann.
  die dort verwendeteten Werte für Datum/Zeit sind aber nur temporär
   */
  restoreOriginalUserInput: function(){
    this.Controller.SQ.instance.setTimeNow(this.Controller.SQ.dateTimeActiveUserSelection.timeNow);
    this.Controller.SQ.instance.setTime(this.Controller.SQ.dateTimeActiveUserSelection.time);
    this.Controller.SQ.instance.setDate(this.Controller.SQ.dateTimeActiveUserSelection.date);
  },
  /* Wenn man von einem Beliebigen anderen Kontext ins Stationboard springt und zuvor ein Stboardaufruf über den Trip Planner stattgefunden hat, muss hier die Funktion zum Zurücksetzen
  der Datums/Zeitangaben gerufen werden
   */
  contextChangedToSQ: function(){
    if(this.Controller.SQ.searchFromOtherContextActive && this.Controller.SQ.dateTimeActiveUserSelection !== undefined) {
       Hafas.bind(this.Controller.SQ.restoreOriginalUserInput,this)();
    }
  },
  initDirection: function (data) {
    var model = this.Controller.SQ.options.getModelById({id: 'HFS_SQDirection'});
    if (model != null && (Hafas("#HFS_Suggest_HFS_SQDirection") == null)) {
      this.Controller.SQ['inpDir'] = Hafas.Core.newType('hafasSuggest', {
        loc: "HFS_SQDirection",
        config: {useChooseFromMap: false, preventDefaultOnEnter: true},
        type: "V"
      });
      this.Controller.SQ['inpDir'].setSuggestType("S");
      var visibility = false;
      if (model.value != "") {
        visibility = true;
      }
      Hafas.ps.pub('/options/gui/toggle/delete', [{id: "HFS_SQDirection", visibility: visibility}]);
    }
  },
  updateIndexHistory: function () {
    Hafas.Modules.History.addOrUpdateData('SQ', 'index', {
      dateTime: {
        date: this.instance.getDate(),
        time: this.instance.getTime(),
        isNowMode: this.instance.getTimeNow()
      }
    });
  },
  validateSelection: function () {
    // form validieren
    this.Controller.SQ.validate(['Station'], Hafas.bind(function () {
      Hafas.Core.newType("hafasValidation", {
        form: this.Controller.SQ.currentForm
      });
    }, this));
  },
  setDateTime: function (hciDate, hciTime, timeNow) {
    this.instance.setTime(hciTime);
    this.instance.setDate(hciDate);
    this.instance.setTimeNow(timeNow);
    // Es wird sich jede Auswahl des Users in einem separaten Feld gemerkt, wir brauchen diese Werte für eine spätere Wiederherstellung
    this.dateTimeActiveUserSelection = {
      timeNow: timeNow,
      time: hciTime,
      date: hciDate
    }
  },
  selectDateTimeFromPicker: function (hciDate, hciTime, dir, timeNow) {
    this.Controller.SQ.setDateTime(hciDate, hciTime, timeNow);
    this.Controller.SQ.updateIndexHistory();
  },
  setAllProducts: function (onOrOff) {
    var onBool = onOrOff == "on";
    var productList = Hafas.Util.products.getForContext("SQ");
    var options = {selectedProducts: []};
    for (var i = 0; i < productList.length; i++) {
      var productClass = productList[i];
      this.Controller.SQ.instance.setProductClass(productClass.bit, onBool);
      options.selectedProducts.push({bit: productClass.bit, value: onBool});
    }
    this.Controller.SQ.options.setOptionModel(options);
  },
  setDirection: function (loc) {
    this.Controller.SQ.instance.setDirection(loc);
    this.Controller.SQ.options.setRandomParameter("HFS_SQDirection", "value", loc);
    var suggest = Hafas.Modules.Suggest.getSuggestInstanceById("HFS_SQDirection");
    if (suggest) {
      suggest.setLocation(loc);
    }
  },
  getLocationsNear: function () {
    this.Controller.SQ.inpStation.getNearbyStops();
  },
  /**
   * sets a platform filter in the SQ instance, set null to remove filter
   *
   * @property platf
   * @type {String}
   */
  setPlatform: function(platf){
    this.Controller.SQ.instance.setPlatform(platf);
  },
  postForm: function (data) {
    // Parameter direkt wieder löschen, wird nur für die initiale Erkennung relevant
    delete this.Controller.Common.initialStartSet;

    if (typeof data.ev != 'undefined')
      data.ev.preventDefault();
    var me = this;

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');

    // close all open tabs
    Hafas.ps.pub('/GUI/tabs/closeAll');

    // Vorherige Auswahl aus der Karte löschen
    Hafas.bind(this.Controller.Map.closeToolbox, this)();

    // Vorherige Stops in der Nähe ausblenden sofern vorhanden:
    Hafas.bind(this.Controller.SQ.hideStopsNearby, this)();

    // Productfilter für Ergebnisse zurücksetzen
    this.Controller.SQ.instance.resetProductResultFilter();

    this.Controller.SQ.validate(['Station'], Hafas.bind(function () {
      var form = Hafas.Core.newType("hafasValidation", {
        form: data.form
      });
      if (form.valid) {
        // show loadingImage and set Button to disabled
        if (data.form.elements.submitSQForm) {
          Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitSQForm);
        }

        // Track
        Hafas.ps.pub('/tracking/event/stationboard-request', [{
          typ: 'event',
          key: 'stationboard-request',
          data: {type: 'initial'}
        }]);
        Hafas.ps.pub('/tracking/event/stationboard-request-triggered', [{
          typ: 'event',
          key: 'stationboard-request-triggered',
          data: {type: 'initial'}
        }]);

        Hafas.bind(this.Controller.SQ.setModeValueController,this)('time');
        Hafas.bind(this.Controller.SQ.setModeValueController,this)('sort');

        Hafas.bind(this.Controller.SQ.resetResults, this)();
        this.Controller.SQ.renderStationboardTabs.bind(this, true)();
        this.Controller.SQ.instance.search();
      }
    }, this));

    Hafas.ps.pub('/app/events/resize');
    return false;
  },
  validate: function (items, callback) {
    var sqController = this.main.Controller.SQ;
    var resolvedCount = 0;
    var itemLength = items.length;

    // Increments the counter, firing the callback when all items are resolved
    function resolveMe() {
      resolvedCount++;
      if (resolvedCount === itemLength) {
        callback();
      }
    }

    for (var i = 0; i < itemLength; i++) {
      var location = sqController.instance.getLocation();
      var input = sqController.inpStation;
      var inputText = input.getInputText();

      // location and inputtext aren't synchronized.
      if(!location && inputText) {
        location = {name:inputText};
      }

      // Location is valid -> resolve
      if (Hafas.Util.location.isValid(location) && Hafas.Util.getLocationAttribute(location,'name') === inputText) {
        resolveMe();
      } else {
        // Something is missing in location -> validate -> LocMatch -> resolve
        if(Object.keys(location).length > 0) {
          input.validateLocation(true, resolveMe);
        } else {
          // Empty Location -> resolve -> show error (see validateQueryLocations)
          resolveMe();
        }
      }
    }
  },
  resetResults: function () {

    var resultHolder = Hafas('#SQ_ResultOverview');
    if (resultHolder && resultHolder.childNodes.length !== 0) {
      this.Controller.SQ.instance.resetData();
      this.Controller.SQ.SegmentedControl.destroy();
      this.Controller.SQ.SegmentedControl = null;
      while (resultHolder.firstChild) {
        resultHolder.removeChild(resultHolder.firstChild);
      }
    }
  },

  /**
   * Oeffnet das Stationboard Ergebniss von einem anderen Context aus.
   * @param data
   * @param view <String> optional "info", "arr", "dep"
   */
  searchFromOtherContext: function (locKey, view, opts) {
    opts = opts || {};
    // Flag setzen, dass wir uns gerade im Modus "Suche aus anderem Kontext" befinden
    this.Controller.SQ.searchFromOtherContextActive = true;

    var location = Hafas.Modules.Render.objectKeeper.get(locKey);
    view = view || "dep";
    Hafas.ps.pub('/app/switchContext', [{context: 'SQ', method: null}]);
    // PageContent muss wieder eingeblendet werden, da er zuvor im GUI Controller ausgeblendet wird
    if (this.layoutClass == "small") {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), true);
      Hafas.ps.pub('/GUI/map/hide', []);
    }

    Hafas.bind(this.Controller.SQ.resetResults, this)();

    Hafas.ps.pub('/app/events/resize');

    var sqInstance = this.Controller.SQ.instance;

    sqInstance.setBoardType(view);
    sqInstance.setLocation(location);

    // Falls Datum und/oder Zeit übergeben worden sind, entsprechend setzen
    if(opts.date !== undefined || opts.time !== undefined){
      sqInstance.setTimeNow(false);
    }
    if(opts.date !== undefined) {
      sqInstance.setDate(opts.date);
    }
    if(opts.time !== undefined){
      sqInstance.setTime(opts.time);
    }

    if (Hafas.Config.Switches.useFavorites) {
      this.Controller.Favorites.instance.addLocation(location, 'History');
    }

    if (Hafas.Config.SQ.unifiedPlanner.show) {
      Hafas.bind(this.Controller.SQ.index, this)();
    }

    // Switch to result (ghost loading view immediately)
    this.Controller.SQ.renderStationboardTabs.bind(this, true)();

    if (view === "info") {
      this.Controller.SQ.instance.getInfo();
    }else {
      this.Controller.SQ.instance.search();
    }
  },
  setLocation: function (loc) {

    var $inputEl = Hafas('#Station');
    if ($inputEl) {
      var locationName = Hafas.Util.getLocationAttribute(loc, "name");
      var newVal = !!loc ? locationName : null;

      // only set value if it's different to the current one
      if ($inputEl.value !== newVal) {
        this.Controller.SQ.inpStation.setLocation(loc);

        var label = Hafas('label[for="' + $inputEl.id + '"]');
        if (label)
          Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
            element: label.textContent,
            text: newVal
          }));
      }
    }

    Hafas.bind(this.Controller.SQ.setLocationMarker, this)(loc);
  },
  /**
   * Fills the station board form with the station from storage if storage is allowed and set.
   * @param loc HCILocation
   */
  setLocationFromSuggest: function (loc) {
    this.Controller.SQ.instance.setLocation(loc);
    if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest) {
      this.Controller.SQ.instance.addLocation(loc, 'History');
    }
    Hafas.Modules.Validation.resetErrorField('Station');
  },

  /**
   * Set SQ marker on map and zoom to marker
   * @param loc
   */
  setLocationMarker: function (loc) {
    var mapController = this.Controller.Map;
    var mapInstance = mapController.instance;

    // Remove previous station marker
    Hafas.bind(this.Controller.SQ.removeStationMarker, this)();

    // Hide previous nearby stops if there are any
    Hafas.bind(this.Controller.SQ.hideStopsNearby, this)();

    // Remove previous flyout from map unless new location is the same
    var currentMapLocation = this.Controller.Map.instance.currentLocation;
    if (!currentMapLocation || currentMapLocation.lid !== loc.lid) {
      Hafas.bind(this.Controller.Map.closeToolbox, this)();
    }

    if (loc != null && loc.lid !== undefined && Hafas.Config.Switches.useMap === true) {
      var tmpX = loc.crd.x;
      var tmpY = loc.crd.y;
      if (tmpX && tmpY) {
        var crd = Hafas.Core.newType("hafasCCoord", {
          lon: tmpX,
          lat: tmpY
        });
        var markerTmpl = 'SELECTION';
        var markerCfg = Hafas.Config.Maps.Marker;
        var params = {
          type: 'location',
          coord: crd,
          imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_' + markerTmpl),
          imagewidth: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_WIDTH'],
          imageheight: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_HEIGHT'],
          hotspot: {
            x: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_X'],
            y: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_Y']
          },
          text: loc.name,
          priority: 10000,
          draggable: Hafas.Config.Maps.enableDragAndDrop,
          onDrag: function (coord, marker, map) {

          },
          onclick: function (hciLoc) {
            return function () {
              Hafas.ps.pub('/map/clickOnLocation', [mapInstance, hciLoc]);
              if (Hafas.Config.Maps.toolbox.showLines == true && hciLoc.type == 'S' && typeof common == 'undefined') {
                Hafas.ps.pub('/map/clickOnLocation/getLocDetails', [hciLoc]);
              }
            };
          }(loc)
        };
        this.stationMarker = mapInstance.createContent(params);
        mapInstance.showContent(this.stationMarker);
        mapInstance.centerToContent(this.stationMarker, {zoom: 14});
        mapInstance.currentPositionMarker = this.stationMarker;
      }
    }
  },
  removeStationMarker: function () {
    var mapController = this.Controller.Map;
    var mapInstance = mapController.instance;
    if (this.stationMarker != null) {
      mapInstance.hideContent(this.stationMarker);
      mapInstance.removeContent(this.stationMarker);
      this.stationMarker = null;
    }
  },
  /**
   * Setzt den Location Marker für die SQ Info-Tab Map
   * @param {*} loc Location, die als Marker angezeigt werden soll
   */
  setInfoLocationMarker: function (loc) {
    if (loc != null) {
      var tmpX = loc.crd.x;
      var tmpY = loc.crd.y;
      if (tmpX && tmpY) {
        var crd = Hafas.Core.newType("hafasCCoord", {
          lon: tmpX,
          lat: tmpY
        });
        var markerTmpl = 'SELECTION';
        var markerCfg = Hafas.Config.Maps.Marker;
        var params = {
          type: 'location',
          coord: crd,
          imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_' + markerTmpl),
          imagewidth: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_WIDTH'],
          imageheight: markerCfg['DEFAULT_MARKER_URL_' + markerTmpl + '_HEIGHT'],
          hotspot: {
            x: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_X'],
            y: markerCfg['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_Y']
          },
          text: loc.name,
          priority: 10000,
          draggable: false
        };
        this.stationInfoMarker = this.Controller.SQ.infoMap.createContent(params);
        this.Controller.SQ.infoMap.showContent(this.stationInfoMarker);
        this.Controller.SQ.infoMap.centerToContent(this.stationInfoMarker, {zoom: 14});
        this.Controller.SQ.infoMap.currentPositionMarker = this.stationInfoMarker;
      }
    }
  },
  showMapToolboxForStation: function (locKey) {
    var loc = Hafas.Modules.Render.objectKeeper.get(locKey);
    Hafas.ps.pub('/map/clickOnLocation', [this.Controller.Map.instance, loc, null, {}, {lazyLoadLines: false}]);
    this.Controller.SQ.zoomMapToStation(loc);
  },
  zoomMapToStation: function (station) {
    Hafas.Util.maps.centerHCILocations(station, this.main.Controller.Map.instance, Hafas.Config.Maps.searchPredefinedZoom);
    // this.main.Controller.Map.instance.centerToGeo(centerHCILocations(station), Hafas.Config.Maps.searchPredefinedZoom);
  },
  setDate: function (hciDate) {
    this.Controller.SQ.instance.setDate(hciDate);
    this.Controller.SQ.instance.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.setDate(hciDate);
    this.Controller.SQ.dateTimePicker.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.updateDisplay();
  },
  setTime: function (hciTime) {
    this.Controller.SQ.instance.setTime(hciTime);
    this.Controller.SQ.instance.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.setTime(hciTime);
    this.Controller.SQ.dateTimePicker.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.updateDisplay();
  },
  changeStationboardTab: function (data) {
    var newBoardType = data.trigger.getAttribute('data-sqtab');
    // Blende Button bei boardType Info aus
    Hafas.Util.gui.setVisibility(Hafas('#HFS_SQFilterSetBtn', false), (newBoardType !== 'info'));
    Hafas.Util.gui.setVisibility(Hafas('#HFS_SQRefreshBtn', false), (newBoardType !== 'info'));
    this.Controller.SQ.instance.setBoardType(newBoardType);
    if (!data.trigger.hasAttribute('data-changed') || data.trigger.getAttribute('data-changed') === 'true') {
      // data was changed, we need to render the whole tab and header
      Hafas.bind(this.Controller.SQ.renderStationboardTabs, this)(true);
    } else {
      // data was not changed, but we have to update the header to show the correct messages as info tab has different
      // message containers than dep/arr
      var sqData;
      // Get station data as in renderStationboardTabs
      if (newBoardType === 'info') {
        sqData = this.Controller.SQ.instance.getInfoData();
      } else {
        sqData = this.Controller.SQ.instance.getResultData();
      }
      // Render the header again to show the correct messages
      Hafas.bind(this.Controller.SQ.updateResultHeader, this)(sqData.resolvedData);

      // If renderStationboardTabs is called, the whole tab is rendered with (new) data. However even if we just render
      // the header again, the content of the tab has changed due to the segmented control too.
      Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));
    }

    // AutoRefresh behandeln
    this.Controller.SQ.stopAutorefresh();
    if (newBoardType === 'arr' || newBoardType === 'dep') {
      this.Controller.SQ.startAutorefresh();
    }

    // Tracking
    if (typeof newBoardType !== 'undefined') {
      if (newBoardType === 'info') {
        Hafas.ps.pub('/tracking/screen/stationboard-overview-info', [{
          typ: 'screen',
          key: 'stationboard-overview-info'
        }]);
        Hafas.ps.pub('/tracking/screen/stationboard-overview', [{
          typ: 'screen',
          key: 'stationboard-overview',
          data: {type: '-info'}
        }]);
      }
      if (newBoardType === 'dep') {
        Hafas.ps.pub('/tracking/screen/stationboard-overview-departures', [{
          typ: 'screen',
          key: 'stationboard-overview-departures'
        }]);
        Hafas.ps.pub('/tracking/screen/stationboard-overview', [{
          typ: 'screen',
          key: 'stationboard-overview',
          data: {type: '-departures'}
        }]);
      }
      if (newBoardType === 'arr') {
        Hafas.ps.pub('/tracking/screen/stationboard-overview-arrivals', [{
          typ: 'screen',
          key: 'stationboard-overview-arrivals'
        }]);
        Hafas.ps.pub('/tracking/screen/stationboard-overview', [{
          typ: 'screen',
          key: 'stationboard-overview',
          data: {type: '-arrivals'}
        }]);
      }
    }

    // Pub fürs resize beim Loadingpanel
    Hafas.ps.pub('/app/events/resize');
  },
  changeStationboardOptions: function () {
    var segCon = this.Controller.SQ.SegmentedControl.getState();
    if (segCon.buttons) {
      segCon.buttons.forEach(function (t) {
        t.setAttribute('data-changed', 'true');
      });
    }
  },
  renderStationboardTabs: function (dataChanged) {
    var data;
    var template = 'SQ_TplBoardContent';
    var me = this;
    var boardType = this.Controller.SQ.instance.getBoardType();
    var type = me.Controller.SQ.instance.station.type;

    this.Controller.SQ.stopAutorefresh();

    if (boardType === 'arr' || boardType === 'dep') {
      this.Controller.SQ.startAutorefresh();
    }

    // Hole Daten & Setze Template
    if (boardType === 'info') {
      // Gibt Daten zurück oder schießt ein Pub dataChanged
      data = this.Controller.SQ.instance.getInfoData();
      template = 'SQ_TplInfoContent';
    } else {
      // Gibt Daten zurück oder schießt ein Pub dataChanged
      data = this.Controller.SQ.instance.getResultData();
    }
    // Sind die Daten da? Ansonsten Ghostloading Elemente anzeigen
    if (!data) {
      data = {
        isLoading: true
      };
      if (type !== "S") {
        data.isLocation = true;
      }
      template = 'SQ_GhostLoaderGroup'
    }

    // Ist das SegmentedControl schon aktiv? Wenn nicht mach erstmal weiter
    if (typeof this.Controller.SQ.SegmentedControl !== 'undefined' &&
    this.Controller.SQ.SegmentedControl !== null &&
    typeof this.Controller.SQ.SegmentedControl.getState === 'function') {
      var segCon = this.Controller.SQ.SegmentedControl.getState();
      // Wurde in zwischen Zeit ein anderer Tab aktiviert? Dann brich ab
      if (segCon && segCon.trigger && segCon.trigger.getAttribute('data-sqtab') !== boardType) {
        return;
      }
    }

    // Prüfe ob ResultOverview schon gerendert wurde, wenn nicht render.
    var resultHolder = Hafas('#SQ_ResultOverview');

    if (resultHolder && resultHolder.childNodes.length === 0) {
      Hafas.bind(this.Controller.SQ.showInitialResult, this)(data);
      return;
    } else {
      Hafas.bind(this.Controller.SQ.updateResultHeader, this)(data.resolvedData);
      // Es handelt sich um eine Adresse oder ein POI, dann stops nearby anzeigen, sobald Ergebis vorliegt
      if (data.resolvedData !== undefined && data.resolvedData.isLocation == true) {
        var common = data.data.svcResL[0].res.common;
        Hafas.bind(me.Controller.SQ.showStopsNearby, me)(data.resolvedData.sortedByStops, common);
      }
    }

    if (segCon && segCon.buttons && segCon.target) {
      // Sind die Daten neu?
      if (!dataChanged) {
        // Setze Attribut um neu zu rendern
        segCon.buttons.forEach(function (t) {
          t.setAttribute('data-changed', 'true');
        });
      }else{
        // Fire announcment when the data is new and loaded
        Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));
      }
      // Außer beim aktuellen Tab
      segCon.trigger.setAttribute('data-changed', 'false');

      var focusSelector = Hafas.Util.gui.getFocusElementSelector();

      // Render Daten in Tabpanel
      setTimeout(Hafas.Modules.Render.render({
        file: 'sq.result.html',
        target: segCon.target,
        template: template,
        model: data
      }, function () {

        // Notiz: Callback wurde aus dem alten Render Callback übernommen (26.10.17)
        // remove loadingImage
        if (me.trigger) {
          if (me.triggerLoadingImage) {
            try {
              me.trigger.removeChild(me.triggerLoadingImage);
              delete me.triggerLoadingImage;
            } catch (e) {
              // do nothing
            }
          }
          me.trigger.removeAttribute('disabled');
        }

        // Remove loader
        // There may be multiple elements matching '[data-loader]', so get them as an array and iterate
        var loaderList = Hafas('[data-loader]', true);
        loaderList.forEach(loader => loader.remove());

        var refreshBtn = Hafas('#HFS_SQRefreshBtn');
        if (refreshBtn) refreshBtn.disabled = '';

        if (boardType === 'info' && data.isLoading != true) {
          // Info-Tab Karte
          var initCoord = Hafas.Core.newType("hafasCCoord", {
            lon: Hafas.Config.Maps.predefinedArea.lon,
            lat: Hafas.Config.Maps.predefinedArea.lat
          });
          var mapConfigParams = {
            coord: initCoord,
            zoom: Hafas.Config.Maps.predefinedZoom,
            reverseLookup: false,
            layer: [{
              "name": "HAFAS BaseLayer",
              "id": "HafasBaseMap",
              "type": "static",
              "url": Hafas.Config.Maps.staticTileURL,
              "attribution": "&copy; OpenStreetMap contributors",
              "isBaseLayer": true
            }],
            baseLayer: Hafas.Config.Maps.baseLayer,
            controls: false,
            useContextmenu: false
          };
          if(typeof Hafas.Config.Maps.vectorStyle != 'undefined'){
            mapConfigParams.style = Hafas.Config.Maps.vectorStyle;
          }

          // Neue Instanz oder vorhandene anzeigen
          if (me.Controller.SQ.infoMap == null) {
            me.Controller.SQ.infoMap = Hafas.Core.newType("hafasMap" + Hafas.Config.Maps.mapApi, 'HFS_StationInfoMap', mapConfigParams);
          } else {
            me.Controller.SQ.infoMap.show();
          }
          // Station auf Karte markieren
          if (data.resolvedData != null && data.resolvedData.lid != null) {
            Hafas.bind(me.Controller.SQ.setInfoLocationMarker, me)(data.resolvedData);
          }

        }

        // close all open tabs
        Hafas.ps.pub('/GUI/tabs/closeAll');

        // is defined in classic-Version GUI-Functions
        Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

        // Der "Unified Planner" gilt nur für TP, für SQ gibt es kein entsprechendes Konzept /mroe

        // Blende das Formular aus (Classic Version), aber nur wenn der Wert "TP.unifiedPlanner.show"
        // in der Config mit "false" deklariert ist
        if (!Hafas.Config.SQ.unifiedPlanner.show) {
          Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'SQ'}]);
        } else {
          Hafas.ps.pub('/GUI/form/show', [{appcontext: 'SQ'}]);
          (Hafas('#HFS_SubmitSQForm', false) || {}).disabled = "";
        }

        Hafas.ps.pub('/GUI/results/overview/show', [{}]);

        var optionData = {
          parentContainer: Hafas("[data-additional-info='result_sq']"),
          template: 'Common_AtomTplOptionResInfo',
          context: 'SQ'
        };

        Hafas.ps.pub('/options/setChangedOptionsInputForm', [optionData]);

        // focus first Element (Backbutton)
        Hafas.Util.gui.focusFirstElement("#HFS_SQActionBar");

        // Tracking
        var _sortType, _timeInfoMode;
        (me.Controller.SQ.instance.sortType === 'line') ? _sortType = 'grouped' : _sortType = 'chronological';
        (me.Controller.SQ.instance.timeInfoMode === 'countdown') ? _timeInfoMode = 'countdown' : _timeInfoMode = 'bytime';
        Hafas.ps.pub('/tracking/event/stationboard-overview-displayed', [{
          typ: 'event',
          key: 'stationboard-overview-displayed',
          data: {type: _sortType + '+' + _timeInfoMode}
        }]);

        Hafas.ps.pub('/GUI/results/resize', [{
          container: me.resultOverviewContainer,
          appcontext: me.appContext
        }]);
        Hafas.ps.pub('/app/events/resize');

        Hafas.Util.gui.resetScrollTop();

        Hafas.Util.gui.restoreFocus(focusSelector);

        // Wird benötigt beim Aufruf aus einem anderen Context. Da sonst die Map nicht korrekt zentriert wird.
        if (me.Controller.SQ.infoMap) me.Controller.SQ.infoMap.updateSize();

        if (me.Controller.SQ.focusSelector) {
          Hafas.Util.gui.restoreFocus(me.Controller.SQ.focusSelector);
          me.Controller.SQ.focusSelector = null; // avoid unintentionally restoring focus later on
        }

      }), 0.1);
    } else {
      // console.warn('Fehler beim Rendern!?',segCon && segCon.buttons && segCon.target);
    }
  },
  updateResultHeader: function (data) {
    // Update Ergebnis
    // Übernahme von Location aus der Map!
    if (data) {
      var template = 'SQ_TplStationHeader';
      if (data.isLoading !== undefined) {
        template = 'SQ_TplStationHeaderLoading';
      }
      if (data && data.location) {
        this.Controller.SQ.instance.setLocation(data.location);
        if (this.Controller.SQ.inpStation)
          this.Controller.SQ.inpStation.setLocation(data.location);
      }
      Hafas.Modules.Render.render({
        file: 'sq.result.html',
        target: 'HFS_SQ_ResultHeaderWrap',
        template: template,
        model: data
      }, function (html) {
      });
    }
  },
  getFurtherJourneys: function () {
    var me = this;
    var segCon = me.Controller.SQ.SegmentedControl.getState();

    // Scroll to top
    var scrollContainer = Hafas('#' + segCon.target.id + ' .lyr_flexScrolledContainer', false);
    var scrollDuration = 400;
    Hafas.Util.gui.smoothScroll(scrollContainer, 0, scrollDuration);

    setTimeout(function() {
      // Show ghost loading elements while journeys are loading
      Hafas.Modules.Render.render({
        file: 'sq.result.html',
        target: segCon.target,
        template: 'SQ_GhostLoaderGroup',
        model: {}
      });
      me.Controller.SQ.instance.getFurtherJourneys();
    }, scrollDuration + 250);
  },
  showInitialResult: function (data) {
    var me = this;

    Hafas.bind(me.Controller.GUI.common.hidePageLoader, me)();

    if (Hafas.Modules.History) {
      Hafas.Modules.History.addOrUpdateData("SQ", "result", data);
    }
    // Übernahme aus verschiedenen Quellen // TODO: DATENKONSISTENZ!
    data = data || {};
    var renderData = data.resolvedData || data || {};

    var tmpX = me.Controller.SQ.instance.station.crd.x;
    var tmpY = me.Controller.SQ.instance.station.crd.y;

    Hafas.ps.pub('/trm/setLocation', ['DEPARTURE_BOARD', {y: tmpY, x: tmpX}]);

    if (!Hafas.Config.Favorites.addLocationOnSuggest) {
      // wenn die Location nicht aus der SuggestList zur History hinzugefügt werden soll, wird sie hier hinzugefügt
      var station = me.Controller.SQ.instance.station;
      // location zu Verlauf hinzufügen
      me.Controller.Favorites.instance.addLocation(station, 'History',undefined, false);
    }

    // Neues SegmentedControl
    me.Controller.SQ.SegmentedControl = Hafas.Core.newType('HafasSegmentedControl', {
      holder: 'HFS_SQResultSegCon',
      callback: Hafas.bind(me.Controller.SQ.changeStationboardTab, me)
    });

    renderData.timeInfoMode = me.Controller.SQ.instance.getTimeMode();
    renderData.sortType = me.Controller.SQ.instance.getSortType();
    renderData.boardType = me.Controller.SQ.instance.getBoardType().toLowerCase();
    renderData.storeSortOptionsLocally = me.Controller.SQ.storeSortOptionsLocally;

    // es kann beim History-Back vorkommen, dass der boardType "info" trotz Adresssuche übergeben wird
    // dann muss der boardType überschrieben werden, weil es sonst zu einem JS-Fehler kommt
    if ((renderData.boardType == "info") && (data.resolvedData !== undefined && data.resolvedData.useInfo == false)) {
      renderData.boardType = "dep";
    }

    window.setTimeout(Hafas.bind(function () {
      Hafas.Modules.Render.render({
        file: 'sq.result.html',
        target: 'SQ_ResultOverview',
        template: 'SQ_TplResult',
        model: renderData
      }, function () {

        // remove loadingImage
        if (me.trigger) {
          if (me.triggerLoadingImage) {
            try {
              me.trigger.removeChild(me.triggerLoadingImage);
              delete me.triggerLoadingImage;
            } catch (e) {
              // do nothing
            }
          }
          me.trigger.removeAttribute('disabled');
        }

        // close all open tabs
        Hafas.ps.pub('/GUI/tabs/closeAll');

        // is defined in classic-Version GUI-Functions
        Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

        // Der "Unified Planner" gilt nur für TP, für SQ gibt es kein entsprechendes Konzept /mroe
        // Übernahme vorerst nur aus ÖBB übernommen, immer noch kein Konzept
        if (!Hafas.Config.SQ.unifiedPlanner.show) {
          Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'SQ'}]);
        } else {
          Hafas.ps.pub('/GUI/form/show', [{appcontext: 'SQ'}]);
            Hafas.ps.pub('/GUI/tabNavigationHeading/hide', []); // Beim Unified Planner muss explizit die TabNavigationHeading auf der Overview ausgeblendet werden
          (Hafas('#HFS_SubmitSQForm', false) || {}).disabled = "";
          // Only show Action bar if WebApp is not formbased
          if(Hafas.Util.isFormBased() == false) {
            Hafas.Util.gui.setVisibility(Hafas('#HFS_SQActionBar', false), true);
          }
          Hafas.Util.gui.setVisibility(Hafas('#HFS_CustomerFavoritesWrap', false), false);
        }


        var optionData = {
          parentContainer: Hafas("[data-additional-info='result_sq']"),
          template: 'Common_AtomTplOptionResInfo',
          context: 'SQ'
        };

        var coordList = me.Controller.SQ.getCoordsFromResult(renderData);
        Hafas.ps.pub('/options/setChangedOptionsInputForm', [optionData]);
        Hafas.ps.pub('/app/updateBanner', ['sqResult', coordList]);
        Hafas.ps.pub('/GUI/results/resize', [{container: me.resultOverviewContainer, appcontext: me.appContext}]);
        Hafas.ps.pub('/app/events/resize');

        // SegmentedControl init+callback
        me.Controller.SQ.SegmentedControl.initiate();

        Hafas.Util.gui.resetScrollTop();
      });
    }, this), 1);
  },
  getCoordsFromResult: function (result) {
    if (Hafas.Util.checkPath(result, "journey.0.st.coord")) {
      var coord = result.journey[0].st.coord
      return [coord];
    }
    return null;
  },
  showStopsNearby: function (stops, common) {
    for (var s = 0; s < stops.length; s++) {
      if(Hafas.Config.Maps.stationIconMode?.useStationIconsFromServer === 'NO' || Hafas.Config.Maps.stationIconMode?.useStationIconsFromServer === 'NO_MAP'){
        var stopIcon = Hafas.Util.getImage(Hafas.Config.Maps.stationIconMode.icoResolved.res);
      }
      else {
        var stopIcon = Hafas.Util.getImage(common.icoL[stops[s].icoX].res);
      }
      var tmpMarker = Hafas.Util.maps.showHCILocation(stops[s], this.Controller.Map.instance, {
        imagewidth: Hafas.Config.Maps.Marker.DEFAULT_MARKER_WIDTH,
        imageheight: Hafas.Config.Maps.Marker.DEFAULT_MARKER_HEIGHT,
        imageurl: stopIcon,
        hotspot: {x: Hafas.Config.Maps.Marker.DEFAULT_MARKER_WIDTH / 2, y: Hafas.Config.Maps.Marker.DEFAULT_MARKER_HEIGHT / 2}
      },
      false, {selectable: true, priority: 50000000, common: common});
      this.Controller.SQ.stopsNearby.push(tmpMarker);
      this.Controller.Map.instance.centerToContent(this.Controller.SQ.stopsNearby);
    }
  },
  hideStopsNearby: function () {
    for (var s = 0; s < this.Controller.SQ.stopsNearby.length; s++) {
      var tmpStop = this.Controller.SQ.stopsNearby[s];
      this.Controller.Map.instance.hideContent(tmpStop);
      this.Controller.Map.instance.removeContent(tmpStop);
    }
    this.Controller.SQ.stopsNearby = [];
  },

  let: storedOptions = {}, // Only for display options like time mode and sorting on result page

  // Function to set the options for time and sort mode, which is choosen by the user and store it in the local storage [HDSWAPP-3748]
   setTimeModeValue: function (value){
     var storedOptions = {};
     const storedOptionsStr = this.Controller.SQ.storage.get(Hafas.Config.Storage.id + '_SqOptions');
    if (storedOptionsStr) {
      storedOptions = JSON.parse(storedOptionsStr);
    }

    Hafas.Config.SQ.timeModeOption = value;
    storedOptions = {...storedOptions, timeModeOption: value};
    if (storedOptions['sortMode'] === undefined) {
      storedOptions['sortMode'] =  Hafas.Config.SQ.sortType;
    }

    if (Hafas.Config.CookieSettings.functional === true && this.Controller.SQ.storeSortOptionsLocally) {
      this.Controller.SQ.storage.set(Hafas.Config.Storage.id + '_SqOptions', JSON.stringify(storedOptions));
    }
    else {
      Hafas.Config.SQ.timeInfoMode = value;
    }
  },

  setSortTypeValue:function (value) {
    var storedOptions = {};
    const storedOptionsStr = this.Controller.SQ.storage.get(Hafas.Config.Storage.id + '_SqOptions');
    if (storedOptionsStr) {
       storedOptions = JSON.parse(storedOptionsStr);
    }

    Hafas.Config.SQ.sortType = value;
    storedOptions = {...storedOptions, sortMode: value};
    if (storedOptions['timeModeOption'] === undefined) {
      storedOptions['timeModeOption'] = Hafas.Config.SQ.timeInfoMode;
    }

    if (Hafas.Config.CookieSettings.functional === true && this.Controller.SQ.storeSortOptionsLocally) {
      this.Controller.SQ.storage.set(Hafas.Config.Storage.id + '_SqOptions', JSON.stringify(storedOptions));
    }
    else {
      Hafas.Config.SQ.sortType = value;
    }
  },

  toggleTimeMode: function (data) {
    if (typeof data.ev !== 'undefined')
      data.ev.preventDefault();

    var currentSqInstance;
    if (typeof data.miniStboard == 'undefined' || data.miniStboard == false) {
      currentSqInstance = this.Controller.SQ.instance;
    } else {
      currentSqInstance = this.Controller.SQ.additionalInstances['toolbox_' + data.extId];
    }

    if(data.trigger) { // trigger can be the clicked sorting button
      if(!this.Controller.SQ.storeSortOptionsLocally) {
        Hafas.ps.pub('/sq/options/activateLocalStorageSort', [true]);
        // when local storage was disabled and a sort value is actively set, save the other sort value too, as in local storage there might be a different setting than in the GUI
        Hafas.bind(this.Controller.SQ.setSortTypeValue,this)(currentSqInstance.getSortType());
      }
      Hafas.ps.pub('/GUI/results/overviewSQ/tabbar/hide', [data]);
    }

    if (typeof data.timeType != "undefined") {
      // timeType given by e.g. via URL
      if (data.timeType === "time") {
        // set time to be displayed as time
        currentSqInstance.setTimeMode("time");
        Hafas.bind(this.Controller.SQ.setTimeModeValue,this)("time");
      } else if (data.timeType === "countdown") {
        // set time to be displayed as countdown
        currentSqInstance.setTimeMode("countdown");
        Hafas.bind(this.Controller.SQ.setTimeModeValue,this)("countdown");
      }
      Hafas.bind(this.Controller.SQ.setModeValueController,this)('time', data.timeType);
    }
    else {
      // data.timeType is undefined, e.g. on click of sorting buttons
      if (Hafas.Util.isCookieTypeActive('functional') === true) {
        // functional cookies accepted
        if (this.Controller.SQ.storage.get(Hafas.Config.Storage.id + '_SqOptions') == "time") {
          // if time, toggle to countdown => never true as _SqOptions is an object with time and sort data, not a string
          Hafas.bind(this.Controller.SQ.setTimeModeValue,this)("countdown");
          currentSqInstance.setTimeMode("countdown");
        }
        else if (currentSqInstance.getTimeMode() === "countdown") {
          // if countdown, toggle to time
          currentSqInstance.setTimeMode("time");
          Hafas.bind(this.Controller.SQ.setTimeModeValue,this)("time");
        }
        else if (currentSqInstance.getTimeMode() === "time") {
          // if time, toggle to countdown
          Hafas.bind(this.Controller.SQ.setTimeModeValue,this)("countdown");
          currentSqInstance.setTimeMode("countdown");
        }
        Hafas.bind(this.Controller.SQ.setModeValueController,this)('time', currentSqInstance.getTimeMode());
      }
      else {
        // functional cookies not accepted
        if (currentSqInstance.getTimeMode() === "countdown") {
          // if countdown, toggle to time
          currentSqInstance.setTimeMode("time");
          Hafas.bind(this.Controller.SQ.setTimeModeValue,this)("time");
        }
        else if (currentSqInstance.getTimeMode() === "time") {
          // if time, toggle to countdown
          currentSqInstance.setTimeMode("countdown");
          Hafas.bind(this.Controller.SQ.setTimeModeValue,this)("countdown");
        }
        Hafas.bind(this.Controller.SQ.setModeValueController,this)('time', currentSqInstance.getTimeMode());
      }
    }
    if(data.trigger) {
      if (typeof data.miniStboard == 'undefined' || data.miniStboard == false) {
        Hafas.bind(this.Controller.SQ.changeStationboardOptions, this)(true);
        Hafas.bind(this.Controller.SQ.renderStationboardTabs, this)(true);
      } else {
        Hafas.bind(this.Controller.SQ.showMiniStboard, this)(data.extId);
      }
    }
  },
  toggleSortType: function (data) {
    if (typeof data.ev !== 'undefined')
      data.ev.preventDefault();

    var currentSqInstance;
    if (typeof data.miniStboard == 'undefined' || data.miniStboard == false) {
      currentSqInstance = this.Controller.SQ.instance;
    } else {
      currentSqInstance = this.Controller.SQ.additionalInstances['toolbox_' + data.extId];
    }

    if(data.trigger) { // trigger can be the clicked sorting button
      if(!this.Controller.SQ.storeSortOptionsLocally) {
        Hafas.ps.pub('/sq/options/activateLocalStorageSort', [true]);
        // when local storage was disabled and a sort value is actively set, save the other sort value too, as in local storage there might be a different setting than in the GUI
        Hafas.bind(this.Controller.SQ.setTimeModeValue,this)(currentSqInstance.getTimeMode());
      }
      Hafas.ps.pub('/GUI/results/overviewSQ/tabbar/hide', [data]);
    }

    if (typeof data.sortType != "undefined") {
      // sortType given by e.g. via URL
      if (data.sortType === "time") {
        // sort results by time
        currentSqInstance.setSortType("time");
        Hafas.bind(this.Controller.SQ.setSortTypeValue,this)("time");
      } else if (data.sortType === "line") {
        // sort/group results by line
        currentSqInstance.setSortType("line");
        Hafas.bind(this.Controller.SQ.setSortTypeValue,this)("line");
      }
      Hafas.bind(this.Controller.SQ.setModeValueController,this)( 'sort', data.sortType);
    }
    else {
      // data.sortType is undefined, e.g. on click of sorting buttons
      if (Hafas.Util.isCookieTypeActive('functional') === true) {
        // functional cookies accepted
        if (this.Controller.SQ.storage.get(Hafas.Config.Storage.id + '_SqOptions') == "line") {
          // if line, toggle to line => never true as _SqOptions is an object with time and sort data, not a string
          Hafas.bind(this.Controller.SQ.setSortTypeValue,this)("line");
          currentSqInstance.setSortType("line");
        }
        else if (currentSqInstance.getSortType() === "line") {
          // if line, toggle to time
          currentSqInstance.setSortType("time");
          Hafas.bind(this.Controller.SQ.setSortTypeValue,this)("time");
        }
        else if (currentSqInstance.getSortType() === "time") {
          // if time, toggle to line
          Hafas.bind(this.Controller.SQ.setSortTypeValue,this)("line");
          currentSqInstance.setSortType("line");
        }
        Hafas.bind(this.Controller.SQ.setModeValueController,this)( 'sort', currentSqInstance.getSortType());
      }
      else {
        // functional cookies not accepted
        if (currentSqInstance.getSortType() === "line") {
          // if line, toggle to time
          currentSqInstance.setSortType("time");
          Hafas.bind(this.Controller.SQ.setSortTypeValue,this)("time");
        }
        else if (currentSqInstance.getSortType() === "time") {
          // if time, toggle to line
          currentSqInstance.setSortType("line");
          Hafas.bind(this.Controller.SQ.setSortTypeValue,this)("line");
        }
        Hafas.bind(this.Controller.SQ.setModeValueController,this)( 'sort', currentSqInstance.getSortType());
      }
    }
    if(data.trigger) {
      if (typeof data.miniStboard == 'undefined' || data.miniStboard == false) {
        Hafas.bind(this.Controller.SQ.changeStationboardOptions, this)(true);
        Hafas.bind(this.Controller.SQ.renderStationboardTabs, this)(true);
      } else {
        Hafas.bind(this.Controller.SQ.showMiniStboard, this)(data.extId);
      }
    }
  },
  updateResultProductFilter: function (cls, trigger) {
    var filterStatus;
    if (trigger.getAttribute('aria-pressed') === 'true') {
      filterStatus = false;
      trigger.setAttribute('aria-pressed', 'false');
    } else {
      trigger.setAttribute('aria-pressed', 'true');
      filterStatus = true;
    }
    this.Controller.SQ.instance.setProductResultFilter(cls, filterStatus);
    Hafas.bind(this.Controller.SQ.announceFilterChange, this)(cls, filterStatus);
    Hafas.bind(this.Controller.SQ.changeStationboardOptions, this)(true);
    Hafas.bind(this.Controller.SQ.renderStationboardTabs, this)(true);
  },
  announceFilterChange: function (bit, filterStatus) {
    for (var i = 0; i < this.Controller.SQ.fltrL.length; i++) {
      if (this.Controller.SQ.fltrL[i].bit === bit) {
        if (this.Controller.SQ.fltrL[i].product.isFromServerConfig) {
          var name = this.Controller.SQ.fltrL[i].product.nameLong;
        } else {
          var name = Hafas.Modules.i18n.get(this.Controller.SQ.fltrL[i].product.name);
        }
        var announcement = Hafas.Modules.i18n.get("a11y.t_N_prodFilter") + " " + name + " ";
        announcement += (filterStatus) ? Hafas.Modules.i18n.get("a11y.t_N_activated") : Hafas.Modules.i18n.get("a11y.t_N_deactivated");
      }
    }
    Hafas.Modules.a11y.Announce.assertive(announcement);
  },
  closeView: function (histData) {
    switch (histData.view) {
      case "index":
        break;
      case "result":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);

        if (Hafas.Config.SQ.unifiedPlanner.show) {
          Hafas.Util.gui.setVisibility(Hafas('#HFS_SQActionBar', false), false);
          Hafas.Util.gui.setVisibility(Hafas('#HFS_CustomerFavoritesWrap', false), true);
        }
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
      case "options":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: false, view: 'options'}]);
        break;
      case "optionsDetails":
        histData.data.open = false;
        // Hafas.ps.pub('/GUI/options/details/toggle', [histData.data]);
        Hafas.ps.pub('/options/gui/toggle/group', [{
          groupId: 'HFS_SQProducts',
          target: 'HFS_SQProducts_Panel',
          view: 'optionsDetails',
          open: false
        }]);
        break;
      case "editSmartLocations":
        Hafas.ps.pub('/favorites/smartLocations/closeView');
        break;
    }
  },
  restoreView: function (histData) {
    var me = this;
    var view = histData.view;
    switch (view) {
      case "index":
        // Send Metadata info for leaving the SQ result context
        this.Controller.App.sendMetaInformation("SQ", "index");

        Hafas.bind(this.Controller.SQ.index, this)(histData.data);
        this.Controller.SQ.instance.setPlatform(null);
        break;
      case "result":
        if (Hafas.Util.isFormBased()) {
          Hafas.Util.gui.setVisibility(Hafas('#HFS_CustomerOptionsWrap', false), false);
        }
        if (Hafas.Config.SQ.unifiedPlanner.show && this.Controller.SQ.options.haveOptionsChanged()) {
          Hafas.ps.pub('/GUI/form/show', [{appcontext: 'SQ'}]);
          (Hafas('#HFS_SubmitSQForm', false) || {}).disabled = true;
          // Only show Action bar if WebApp is not formbased
          if (Hafas.Util.isFormBased() === false) {
            Hafas.Util.gui.setVisibility(Hafas('#HFS_SQActionBar', false), true);
          }
          Hafas.Util.gui.setVisibility(Hafas('#HFS_CustomerFavoritesWrap', false), false);
          this.Controller.SQ.instance.search(Hafas.bind(this.Controller.SQ.showInitialResult, this));
        } else {
          Hafas.bind(this.Controller.SQ.showInitialResult, this)(histData.data);
        }
        break;
      case "options":
        Hafas.bind(me.Controller.SQ.index, me)();
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: true, view: 'options'}]);
        break;
      case "optionsDetails":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{open: true}]);
        histData.data.open = true;
        Hafas.ps.pub('/GUI/options/details/toggle', [histData.data]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderDefault'}]);
        break;
      case "editSmartLocations":
        Hafas.ps.pub('/favorites/smartLocations/edit', [{locKey: Hafas.Modules.Render.objectKeeper.keep(histData.data.loc), target: this.smartLocationsContainer}]);
        break;
    }
  },
  refresh: function (data) {
    this.Controller.SQ.focusSelector = Hafas.Util.gui.getFocusElementSelector(); // save refresh button selector to restore focus to

    if (data.ev) {
      data.ev.preventDefault();
      data.ev.stopPropagation();
    }
    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get("a11y.announce.t_N_areUpdating", {elem: Hafas.Modules.i18n.get("common.label.t_N_Departures")}));
    // Add Loader
    var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite");
    // Der Loader liegt beim unifiedPlanner anders
    if (Hafas.Config.SQ.unifiedPlanner.show) {
      Hafas('[data-render-element="fieldset_wrapper"]').insertAdjacentHTML('afterbegin', loaderHtml);
    } else {
      Hafas('#SQ_ResultOverview [data-render-element="result_header"]').insertAdjacentHTML('afterbegin', loaderHtml);
    }
    var refreshBtn = Hafas('#HFS_SQRefreshBtn');
    if (refreshBtn) refreshBtn.disabled = true;

    this.Controller.SQ.instance.search();

  },
  stopAutorefresh: function (data) {
    // Stationboard Autofresh einstellen, wenn Applikation gewechselt wird
    if (typeof this.instance != 'undefined' && this.instance != null) {
      if (data == null || data.context != 'SQ') {
        this.instance.stopAutorefresh();
      }
    }
  },
  startAutorefresh: function (data) {
    // Stationboard Autofresh aktivieren
    if (typeof this.instance != 'undefined' && this.instance != null) {
      if (data == null || data.context != 'SQ') {
        this.instance.startAutorefresh();
      }
    }
  },
  /**
   * removes map content (that has been created in the statioboard context)
   *
   * @method clearMap
   */
  clearMap: function(){
    Hafas.bind(this.Controller.SQ.removeStationMarker, this)();
    Hafas.bind(this.Controller.SQ.hideStopsNearby, this)();
  },
  cleanup: function () {
    // Send Metadata info for leaving the SQ result context
    this.Controller.App.sendMetaInformation("SQ", "leaveContext");

    Hafas.ps.pub('/options/gui/close/groups', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    if (Hafas.Config.SQ.unifiedPlanner.show) {
      Hafas.Util.gui.setVisibility(Hafas('#HFS_SQActionBar', false), false);
      Hafas.Util.gui.setVisibility(Hafas('#HFS_CustomerFavoritesWrap', false), true);
    }
    Hafas.ps.pub('/GUI/form/hide', [{}]);
    Hafas.bind(this.Controller.SQ.clearMap, this)();

    // If we have smart locations, close the edit view
    if (Hafas.Config.Switches.useSmartLocations === true) {
      Hafas.ps.pub('/favorites/smartLocations/closeView');
    }

    if (this.Controller.SQ.infoMap != null) {
      this.Controller.SQ.infoMap.remove();
      this.Controller.SQ.infoMap = null;
    }
  },
  setGeoLocationPosition: function (locObj, inputId) {
    this.Controller.SQ.instance.setLocation(locObj);
  },
  toggleMiniStboard: function (show, trigger, options) {
    var location = Hafas.Modules.Render.objectKeeper.get(options.locKey);
    try {
      if (typeof this.Controller.SQ.additionalInstances['toolbox_' + location.extId] == 'undefined') {
        var miniStboardParams = {
          id: 'toolbox_' + location.extId,
          station: location,
          showJourneys: Hafas.Config.SQ.toolboxCfg.maxJourneys,
          sortType: Hafas.Config.SQ.setSortType,
          timeInfoMode: Hafas.Config.SQ.timeInfoMode,
          autorefresh: false,
          sort: 'PT'
        };
        if (typeof options != 'undefined') {
          if (typeof options.pCls != 'undefined') {
            miniStboardParams.prodclasses = options.pCls;
          }
          if (typeof options.sortType != 'undefined') {
            miniStboardParams.sortType = options.sortType;
          }
          if (typeof options.showLineSeparator != 'undefined') {
            miniStboardParams.showLineSeparator = options.showLineSeparator;
          }
        }
        this.Controller.SQ.additionalInstances['toolbox_' + location.extId] = Hafas.Core.newType("hafasStboard", miniStboardParams);
        Hafas.ps.sub('/sq/dataChanged/toolbox_' + location.extId, Hafas.bind(this.Controller.SQ.showMiniStboard, this, location.extId, options));
        this.Controller.SQ.additionalInstances['toolbox_' + location.extId].search();
      } else {
        Hafas.ps.unsub('/sq/dataChanged/toolbox_' + location.extId);
        delete this.Controller.SQ.additionalInstances['toolbox_' + location.extId];
      }
    } catch (e) {
      Hafas.logger.error(Hafas.logger.ERROR_TYPES.JS, "sq.toggleMiniStboard", "", e);
    }
  },
  showMiniStboard: function (extId, options) {
    var me = this;
    this.Controller.SQ.instance.setBoardType('DEP');
    // Hole Daten & Setze Template
    var data = this.Controller.SQ.additionalInstances['toolbox_' + extId].getResultData();
    // Sind die Daten da?
    if (!data) {
      // console.warn('keine Daten!');
      return;
    }

    // Filtereinstellungen verstecken
    // var filterSettings = Hafas('[data-toolbox-stationboard-filterbackground="' + extId + '"]',false);
    // if(filterSettings){
    //   Hafas.Util.gui.setVisibility(filterSettings,false);
    // }

    var targetContainer = Hafas('[data-toolbox-stationboard="' + extId + '"]', false);
    var template = 'SQ_TplResult';

    data.miniStboard = true;
    if (typeof options !== 'undefined') {
      for (var o in options) {
        data.resolvedData[o] = options[o];
      }
    }

    // Render Daten in Tabpanel
    setTimeout(Hafas.Modules.Render.render({
      file: 'sq.result.html',
      target: targetContainer,
      template: template,
      model: data
    }, function () {

    }), 0.1);

    Hafas.Util.gui.setVisibility(Hafas('[data-toolbox-stationboard-filterbackground="' + extId + '"]', false), false);
  },
  loadNearStops: function () {
    var me = this;
    if (Hafas.Config.SQ.useSmartDeparture) {
      Hafas.Util.getGeoLocation(function (geoLocationResponse) {
        var lat = parseInt(geoLocationResponse.coords.latitude * 1000000);
        var lon = parseInt(geoLocationResponse.coords.longitude * 1000000);
        me.Controller.SQ.showNearbyStops(lat, lon);
      }, function (data) {
        me.Controller.SQ.renderStopsNearby([]);
      });
    }
  },
  showNearbyStops: function (lat, lon) {
    // Suche Linien
    var prodfilter = 0;
    for (var s = 0; s < this.currentNearStopsFilter.length; s++) {
      prodfilter += this.currentNearStopsFilter[s];
    }
    // Produktfilter wird hier absichtlich auf "0" gesetzt, damit alle Produkte abgeholt werden
    this.instance.searchNearbyStops({
      callback: Hafas.bind(function (stopList) {
        this.currentNearStops = stopList;
        this.renderStopsNearby(this.currentNearStops);
      }, this), coord: {lat: lat, lon: lon}, prodfilter: 0
    });
  },
  renderStopsNearby: function (stopList) {
    var showStopList = [];
    var maxStops = Hafas.Config.SQ.maxStopsNear || 999999;
    var activeBits = 0;
    for (var f = 0; f < this.fltrL.length; f++) {
      if (this.fltrL[f].active) {
        activeBits += this.fltrL[f].bit;
      }
    }
    var addedStops = 0;
    for (var i = 0; i < stopList.length; i++) {
      var stop = stopList[i];
      var useStop = false;
      if (activeBits != 0) {
        for (var p = 0; p < stop.productRefList.length; p++) {
          if ((stop.productRefList[p].cls & activeBits) == stop.productRefList[p].cls) {
            useStop = true;
            break;
          }
        }
      } else {
        useStop = true;
      }
      if (useStop && addedStops < maxStops) {
        stop.isFav = Hafas.bind(this.main.Controller.SQ.isLocationFavorite, this.main)(stop);
        stop.idxResolved = addedStops;
        showStopList.push(stop);
        addedStops++;
      }

      // Find smart location information
      Hafas.Util.getSmartLocationInfo(stop);
    }

    this.currentShownNearStops = showStopList;

    if (Hafas('#HFS_NearbySQ', false)) {
      var focusSelector = Hafas.Util.gui.getFocusElementSelector();

      var model = {
        stopList: showStopList,
        fltrL: this.fltrL
      };

      Hafas.Modules.Render.render({
        target: 'HFS_NearbySQ',
        template: 'SQ_AtomTplStopsNearby',
        model: model
      }, function (html) {
        Hafas.Util.gui.restoreFocus(focusSelector);

        // If we have stations nearly, simplify their line signets
        if (model.stopList.length > 0) {
          var historyWrapperList = Hafas('#HFS_NearbySQ[data-render-element="history-wrapper"]', true);
          for (var i = 0; i < historyWrapperList.length; i++) {
            var historyWrapper = historyWrapperList[i];
            if (Hafas.Util.gui.isVisible(historyWrapper)) { // Nur ausführen, wenn die Historie / Favoriten auch sichtbar sind
              var historyLocation = Hafas('.hfs_stopSearchProducts', true, historyWrapper);
              if (historyLocation.length > 0) {
                Hafas.Util.gui.simplifyLineSignets(historyWrapper);
              }
            }
          }
        }

        Hafas.ps.pub('/app/events/resize');
      });
    }
  },
  /**
   * helper function to bundle the initiation of an updated stationboard search
   *
   * @method updateSearch
   */
  updateSearch: function(){
    Hafas.bind(this.Controller.SQ.resetResults, this)();
    // Switch to result (ghost loading view immediately)
    this.Controller.SQ.renderStationboardTabs.bind(this, true)();
    this.Controller.SQ.instance.search(Hafas.bind(this.Controller.SQ.showInitialResult, this));
  },
  /**
   * function that is called when user has selected a stop from the nearby stops list, it will trigger a new search
   *
   * @method selectStopFromNearList
   * @param {Object} data - options for opening / initializing the EcoCheck
   * @param {Boolean} data.id - index / id of selected nearby stop
   * @param {Boolean} [data.hitSearch] - if set true, it will automatically trigger a new search, if undefined or false the location will only be set in the SQ instance
   */
  selectStopFromNearList: function (data) {
    var index = data.id;
    var location = this.Controller.SQ.currentShownNearStops[index];
    this.Controller.SQ.instance.setLocation(location);
    // Remove stop near list popover
    if (this.Controller.SQ.StopFromNearListPopover) {
      Hafas.bind(this.Controller.SQ.hideStopFromNearListPopover, this)();
    }
    this.Controller.SQ.instance.resetData();

    if( typeof data.hitSearch !== "undefined") {
      if (data.hitSearch) {
        Hafas.bind(this.Controller.SQ.updateSearch,this)();
      }else{
        // send the input id as a type to highlightingInput method
        Hafas.ps.pub('/GUI/common/highlightingInput', [{type:'station'}]);
      }
    }else {
      Hafas.bind(this.Controller.SQ.updateSearch,this)();
      // send the input id as a type to highlightingInput method
      Hafas.ps.pub('/GUI/common/highlightingInput', [{type:'station'}]);
    }
    Hafas.bind(this.Controller.SQ.setModeValueController,this)('time');
    Hafas.bind(this.Controller.SQ.setModeValueController,this)('sort');
  },

  // Renders the view of the setted options
   setModeValueController:function (mode, type) {
     let value;
     var storedOptions = false;
     if (this.Controller.SQ.storage.get(Hafas.Config.Storage.id + '_SqOptions') != null && !Hafas.Config.CookieSettings.functional) {
       this.Controller.SQ.storage.remove(Hafas.Config.Storage.id + "_SqOptions");
     }
     if (this.Controller.SQ.storeSortOptionsLocally) {
       storedOptions = JSON.parse(this.Controller.SQ.storage.get(Hafas.Config.Storage.id + '_SqOptions'));
     }
    if (!storedOptions) {
      value = type ? type : (mode === 'time' ? Hafas.Config.SQ.timeInfoMode : Hafas.Config.SQ.sortType);
    } else {
      value = mode === 'time' ? storedOptions.timeModeOption : storedOptions.sortMode;
    }
    if (mode === 'time') {
      this.Controller.SQ.instance.setTimeMode(value);
    } else {
      this.Controller.SQ.instance.setSortType(value);
    }
  },

  setProductFormFilter: function (bit, trigger) {
    var filterItem = Hafas.Util.array.getEntryByPropertyValue(this.Controller.SQ.fltrL, 'bit', bit);
    this.Controller.SQ.fltrL[filterItem.index].active = !trigger.getAttribute('aria-pressed');

    var filterBits = [];
    var prodIdx = 0;
    var controllerSQ = this.Controller.SQ;
    for (var i = 0; i < controllerSQ.fltrL.length; i++) {
      if (controllerSQ.fltrL[i].bit == bit) {
        prodIdx = i;
      }
    }
    for (var i = 0; i < controllerSQ.fltrL.length; i++) {
      if (controllerSQ.fltrL[i].active) {
        filterBits.push(controllerSQ.fltrL[i].bit);
      }
    }
    controllerSQ.currentNearStopsFilter = filterBits;
    //Hafas.bind(controllerSQ.loadNearStops,this)();
    Hafas.bind(this.Controller.SQ.announceFilterChange, this)(bit, this.Controller.SQ.getProductFilterStatus(trigger));
    Hafas.bind(this.Controller.SQ.renderStopsNearby, this.Controller.SQ)(this.Controller.SQ.currentNearStops);
  },
  getProductFilterStatus: function (trigger) {
    if (trigger.getAttribute('aria-pressed') === 'true') {
      return false;
    } else {
      return true;
    }
  },
  printSearchLink: function () {
    console.log(this.Controller.SQ.instance.createSearchLink());
  },
  addStopToFav: function (locKey) {
    var data = Hafas.Modules.Render.objectKeeper.get(locKey);
    this.Controller.Favorites.instance.addLocationToFav(data);
  },
  removeStopFromFav: function (locKey) {
    var data = Hafas.Modules.Render.objectKeeper.get(locKey);
    var currentLocIdx = this.Controller.Favorites.instance.getLocationIndex(data);
    this.Controller.Favorites.instance.removeLocationFav(currentLocIdx);
  },
  isLocationFavorite: function (data) {
    return this.Controller.Favorites.instance.isLocationFav(data);
  },
  rerenderLinesNearby: function () {
    this.Controller.SQ.renderStopsNearby(this.Controller.SQ.currentNearStops);
  },
  /**
   * Decides whether the options should be stored locally or not (temporarily [de]activating)
   * @param {Boolean} boolval Sets the value of localOptionsActive
   */
  setOptionStorageActive: function (boolval) {
    if (Hafas.Config.Options && Hafas.Config.Options.storeOptions === true) {
      this.Controller.SQ.localOptionsActive = boolval;
    }
  },
  setSortOptionStorageActive: function (boolval) {
    if (Hafas.Config.Options && Hafas.Config.Options.storeOptions === true) {
      this.Controller.SQ.storeSortOptionsLocally = boolval;
    }
  },
  removeStopFromNearList: function (index) {
    var location = this.Controller.SQ.currentShownNearStops[index];
    Hafas.ps.pub('/favorites/trackDialogAction', ['delete-pressed']);
  },
  showStopFromNearListPopover: function (data, triggerElem) {
    var _me = this;
    // Get kept location for using it in template
    data.loc = Hafas.Modules.Render.objectKeeper.get(data.loc);

    var triggerParent = triggerElem.closest('li');
    triggerParent.addClassName('lyr_selectedFav');
    if (_me.Controller.SQ.StopFromNearListPopover) {
      Hafas.bind(_me.Controller.SQ.hideStopFromNearListPopover, _me)();
    }
    data.popoverCloseEvent = '/sq/favorites/selectStopFromNearList/closePopover';
    _me.Controller.SQ.StopFromNearListPopover = Hafas.Core.newType("HafasOverlay", {
      app: _me,
      title: '',
      anchorElement: triggerParent,
      anchoredOverlay: 'DESKTOP',
      outputHTML: Hafas.Modules.Render.renderTemplate("SQ_AtomTplStopsNearbyItemsPopover", data),
      cssClass: 'lyr_locationSelectPopover',
      onClose: function () {
        var anchor = this.Controller.SQ.StopFromNearListPopover.getAnchorElement();
        if (anchor) {
          anchor.removeClassName('lyr_selectedFav');
        }
        this.Controller.SQ.StopFromNearListPopover = null;
        Hafas.ps.pub('/favorites/trackDialogAction', ['dialog-cancelled']);
      }.bind(this),
      callback: function (html, err) {

      }
    });
  },
  hideStopFromNearListPopover: function () {
    var _me = this;
    if (this.Controller.SQ.StopFromNearListPopover) {
      var anchor = _me.Controller.SQ.StopFromNearListPopover.getAnchorElement();
      if (anchor) {
        anchor.removeClassName('lyr_selectedFav');
      }
      this.Controller.SQ.StopFromNearListPopover.close();
      this.Controller.SQ.StopFromNearListPopover = null;
      Hafas.ps.pub('/favorites/trackDialogAction', ['dialog-cancelled']);
    }
  },

  /**
   * clears all input data (including options)
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt
    Hafas.Modules.History.removeCurrentStep("index", () => {
      Hafas.ps.pub('/app/switchContext', [{context: 'SQ', method: 'index'}]);
    });
    Hafas.ps.pub('/options/reset');
    var me = this;
    me.Controller.SQ.dateTimePicker.setTimeNowOn();
    me.Controller.SQ.inpStation.resetLocation();
    me.Controller.SQ.instance.setLocation(null);
    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  },
  /**
   * Get region by provider (EU Spirit)
   * @param {string} prvId - provider id for comparison
   * @return {Object} result - region
   */
  findEuRegionByProvider: function (prvId) {
    var found = false;
    var optGroup = 0;
    var result = {
      index: 0,
      value: Hafas.Config.euSpiritRegions[0].prvCtx,
      label: Hafas.Config.euSpiritRegions[0].name
    };
    Hafas.Config.euSpiritRegions.forEach(function (region, index) {
      if (!found) {
        // OptGroup hasn't got an index in selectbox
        if (region.optgroup) {
          optGroup++;
        }
        if (region && region.prvCtx) {
          if (region.prvCtx === prvId) {

            result = {
              index: index,
              selectedIndex: index - optGroup,
              value: region.prvCtx,
              optgroup: region.optgroup,
              label: region.name
            };
            found = true;
          } else {
            // Check if provider id is available in provider group (comma separated)
            var configCtx = region.prvCtx.split(',');
            configCtx.forEach(function (cPrvCtx) {
              if (prvId === cPrvCtx) {
                result = {
                  index: index,
                  selectedIndex: index - optGroup,
                  value: region.prvCtx,
                  optgroup: region.optgroup,
                  label: region.name
                };
                found = true;
              }
            });
          }
        }
      }
    });
    return result;
  },
  /**
   * Find region and call function to change the option (EU Spirit)
   * @param {Object} location - location object
   */
  setEuSpiritOption: function (location) {
    if (location) {
      var providerId = Hafas.Util.location.getProviderId(location);
      var region = this.Controller.SQ.findEuRegionByProvider(providerId);
      region.name = 'euRegion';
      Hafas.bind(this.Controller.SQ.changeEUSpiritOption, this)(region);
    }
  },
  /**
   * Set found region into EU Spirit region selection
   * @param {Object} region - EU Spirit region object
   * @param {string} region.value - "euRegion" in this case
   */
  changeEUSpiritOption: function (region) {
    if (typeof region.value === "string") {

      var newRegion = this.Controller.SQ.findEuRegionByProvider(region.value);
      if (!newRegion) return;
      var sqController = this.Controller.SQ;

      if (sqController['euSpiritSelectBox']) {
        var selectBoxState = sqController['euSpiritSelectBox'].getState();
        if (selectBoxState.active !== (newRegion.selectedIndex + 1)) {
          sqController['euSpiritSelectBox'].setActiveIndex(newRegion.selectedIndex + 1);
        }
        sqController['inpStation'].inp.disabled = '';
      }

      // Settings for suggest
      this.Controller.SQ.euProvider['Station'] = {
        label: newRegion.label,
        prvCtx: newRegion.value,
        optgroup: newRegion.optgroup,
        index: newRegion.index
      };

      this.Controller.SQ["inpStation"].setProviderCtx(newRegion.value);
      this.Controller.SQ["inpStation"].setSystem('E');
      this.Controller.SQ.instance.setSystem('E');
    }
  },
};
